import { Component } from '@angular/core';
import { nav_path } from '../../../app-routing.module';
import { companyInformation } from '../../../companyinformation';
import { SeoService } from '../../../core/services/seo.service';

@Component({
  selector: 'anon-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent {
  public readonly nav_path = nav_path;
  public readonly company = companyInformation;
  private title = "Authentication page";

  constructor(private seo: SeoService) {
    seo.generateTags({
      title: this.title,
      description: `Anonymous Systems ${this.title}`,
      route: nav_path.home
    });
  }
}
